<template>
  <transition name="slide-down">
    <div v-if="isOffline" class="offline-indicator">
      <div class="offline-content">
        <font-awesome-icon icon="triangle-exclamation" class="offline-icon" />
        <span class="offline-text">{{ $t('common.youreOffline') }}</span>
      </div>
    </div>
  </transition>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'OfflineIndicator',
  setup() {
    const store = useStore();
    const isOffline = computed(() => store.getters['offline/isOffline']);

    return {
      isOffline
    };
  }
};
</script>

<style lang="scss" scoped>
.offline-indicator {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #ff9800;
  color: white;
  padding: 8px 16px;
  text-align: center;
  z-index: 10000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  
  .offline-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 500;
    
    .offline-icon {
      font-size: 16px;
    }
    
    .offline-text {
      line-height: 1.5;
    }
  }
}

// Slide down animation
.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-down-enter-from {
  transform: translateY(-100%);
  opacity: 0;
}

.slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

// Adjust for mobile safe area
@supports (padding: max(0px)) {
  .offline-indicator {
    padding-top: max(8px, env(safe-area-inset-top));
  }
}
</style>

